import gql from 'graphql-tag';

export default gql`
  query getAllElementsForAdmin {
    elements(order_by: { name: asc }) {
      element_id
      group_id
      name
      description
      data
      created_at
      updated_at
    }
  }
`;
